import { AmplitudeAnalytics } from './AmplitudeAnalytics';
import { LocalAnalytics } from './LocalAnalytics';

export const analytics =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? new AmplitudeAnalytics(process.env.REACT_APP_AMPLITUDE_API_KEY || '')
    : new LocalAnalytics();
